<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="laboratorios"
                    :validations="validations.unidade"
                    label="Laboratório"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="unidadeId"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    label="Local de atendimento"
                    :options="infraestruturas"
                    :validations="validations.infraestrutura"
                    textField="nome"
                    v-model="model.infraestruturaId"
                    valueField="id"
                    show-default-option
                />
            </rkm-col>

            <rkm-col cols="12">
                <rkm-form-input-autocomplete
                    :searchFields="localForm.autocompleteFields.usuario"
                    :repository="repositories.usuario"
                    text-field="cidadaoNome"
                    v-model="model.usuario"
                    :validations="validations.usuario"
                    label="Profissional"
                    uppercase
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { object, repository } from '@/mixins'

export default {

    computed: {
        validations() {

            return {
                usuario: { required: true },
                unidade: { required: true },
                infraestrutura: { required: true },
            }
        },
        hasIndex() {

            return this.index !== null
        },
        laboratorios() {

            const unidades = []

            this.data.model.unidades.filter(u => u.laboratorio).map(unidade => {

                let cadastrada = false

                this.data.model.unidadesFaturamento.forEach(item => {

                    if (item.faturamentoRelacionado.find(relacionada =>
                        relacionada.relacionadaUnidadeId == unidade.unidadeId &&
                        relacionada.relacionadaInfraestruturaId == unidade.infraestruturaId)
                    ) {

                        cadastrada = true
                    }
                })

                if (!cadastrada) {

                    const unidadeInserida = unidades.find(u => u.unidadeId === unidade.unidadeId)

                    if (unidadeInserida) {

                        unidadeInserida.infraestruturas.push({

                            id: unidade.infraestruturaId,
                            nome: unidade.infraestruturaNome,
                            principal: unidade.infraestruturaPrincipal,
                        })

                    } else {

                        unidades.push({

                            unidadeId: unidade.unidadeId,
                            nomeFantasia: unidade.nomeFantasia,
                            infraestruturas: [
                                {
                                    id: unidade.infraestruturaId,
                                    nome: unidade.infraestruturaNome,
                                    principal: unidade.infraestruturaPrincipal,
                                }
                            ]
                        })
                    }
                }
            })

            return unidades
        },
        infraestruturas() {

            if (!this.model.unidadeDisabled) {

                this.resetInfraestrutura()
            }

            if (this.model.unidadeId) {

                let infraestruturaPrincipal = this.laboratorios.find(u => u.unidadeId === this.model.unidadeId).infraestruturas

                if (!this.model.unidadeDisabled) {

                    this.getPrincipal(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal
            }

            return []
        },
    },
   created() {

        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }

        this.load()
    },
    data: () => ({
        localForm: {
            autocompleteFields: {
                usuario: [
                    { key: "cadastroCidadao.nome", searchable: true },
                ],
            },
        },
        model: {
            id: null,
            unidadeId: null,
            usuario: null,
            infraestruturaId: null,
            unidadeDisabled: false,
        },
    }),
   methods: {
        load() {

            if (this.hasIndex) {

                this.model.id = this.item.id
                this.model.unidadeId = this.item.unidadeId
                this.model.infraestruturaId = this.item.infraestruturaId
                this.model.usuario = this.item.usuario
            }
        },
        save() {

            this.$refs.Form.validate()
                 .then(valid => {

                    if (!valid) return

                    if (this.hasOcupacaoParametrizada()) {

                        this.resetForm()

                        this.showValidationNotification("Já existe um registro com o laboratório e usuário.")

                        return
                    }

                    if (!this.hasIndex) {

                        this.model.id = this.uniqueId('usuario' + new Date().getTime())
                    }

                    const unidade = this.data.form.unidades.find(u => u.id === this.model.unidadeId)
                    const infraestrutura = this.infraestruturas.find(u => u.id === this.model.infraestruturaId)

                    const param = {
                        id: this.model.id,
                        usuario: this.model.usuario,
                        nome: this.model.usuario.cidadaoNome,
                        usuarioId: this.model.usuario.id,
                        unidadeId: unidade.id,
                        nomeFantasia: unidade.nomeFantasia,
                        infraestruturaId: infraestrutura.id,
                        infraestruturaNome: infraestrutura.nome,
                    }

                    if (this.hasIndex) {

                        const objIndex = this.data.model.profissionaisAssinatura.findIndex((obj => obj.id == this.model.id));

                        this.$set(this.data.model.profissionaisAssinatura, objIndex, this.clone(param))
                    } else {

                        this.data.model.profissionaisAssinatura.push(this.clone(param))
                    }

                    this.$emit('save', this.clone(param))
                })
        },
        hasOcupacaoParametrizada() {

            return this.data.model.profissionaisAssinatura.find(profissional =>
                profissional.usuarioId === this.model.usuario.id &&
                profissional.unidadeId === this.model.unidadeId &&
                profissional.infraestruturaId === this.model.infraestruturaId &&
                profissional.id !== this.model.id)
        },
        resetForm() {

            this.model.usuario.id = null
            this.model.usuario.cidadaoNome = ''

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        getPrincipal(infraestruturaPrincipal) {

            this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
        },
        resetInfraestrutura() {

            this.model.infraestruturaId = null
        },
    },
    mixins: [object, repository],
    props: {
        data: { type: Object, required: true },
        index: { type: Number, default: null },
        item: { type: Object, default: null },
    },
}
</script>